import { motion } from 'framer-motion'
import { VideoCarousel } from './VideoCarousel'
import { ChevronDown, Shield, Clock, Coins } from 'lucide-react'

const HERO_VIDEOS = [
  '/48bcf5cf-3900-4544-982a-395c64c7931e-opt.mp4',
  '/4be3a216-c2ca-4587-b20c-3130a051690-opt.mp4',
  '/c10c8447-f39c-4961-aebb-c2e2958db1e4-opt.mp4',
]

export const HeroSection = () => {
  return (
    <section className="relative h-screen overflow-hidden">
      {/* Full Screen Video Background */}
      <div className="absolute inset-0">
        <VideoCarousel videos={HERO_VIDEOS} duration={10} />
        {/* Subtle overlay - видео хорошо видно */}
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-black/20" />
      </div>

      {/* Content - компактный, внизу экрана */}
      <div className="relative z-10 h-full flex flex-col justify-end pb-32 px-6">
        <div className="max-w-6xl mx-auto w-full">
          
          {/* Main Content */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center"
          >
            {/* Small badge */}
            <span className="inline-block px-3 py-1 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full text-white/80 text-xs uppercase tracking-wider mb-4">
              Limited Collection • 10,000 NFTs
            </span>

            {/* Title - компактный */}
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-3">
              COSMIC ALCHEMISTS
            </h1>

            {/* Subtitle */}
            <p className="text-base text-white/70 mb-6 max-w-xl mx-auto">
              Premium NFT Collection with Dutch Auction & 7-Day Refund Guarantee
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-wrap gap-3 justify-center mb-8">
              <a
                href="#mint"
                className="px-6 py-3 bg-[#d4a853] hover:bg-[#c49a4a] text-black font-semibold rounded-lg transition-all duration-300 hover:shadow-lg hover:shadow-[#d4a853]/30"
              >
                Mint Now
              </a>
              <a
                href="#gallery"
                className="px-6 py-3 bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white font-medium rounded-lg border border-white/20 transition-all duration-300"
              >
                View Gallery
              </a>
            </div>

            {/* Stats Row */}
            <div className="flex justify-center gap-8 sm:gap-12">
              <div className="text-center">
                <div className="flex items-center justify-center gap-2 mb-1">
                  <Coins className="w-4 h-4 text-[#d4a853]" />
                  <span className="text-xl font-bold text-white">0.5 ETH/BNB</span>
                </div>
                <span className="text-xs text-white/50 uppercase">Start Price</span>
              </div>
              <div className="text-center">
                <div className="flex items-center justify-center gap-2 mb-1">
                  <Shield className="w-4 h-4 text-[#d4a853]" />
                  <span className="text-xl font-bold text-white">10,000</span>
                </div>
                <span className="text-xs text-white/50 uppercase">Total Supply</span>
              </div>
              <div className="text-center">
                <div className="flex items-center justify-center gap-2 mb-1">
                  <Clock className="w-4 h-4 text-[#d4a853]" />
                  <span className="text-xl font-bold text-white">7 Days</span>
                </div>
                <span className="text-xs text-white/50 uppercase">Refund Period</span>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Scroll indicator */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1 }}
          className="absolute bottom-8 left-1/2 -translate-x-1/2"
        >
          <motion.div
            animate={{ y: [0, 6, 0] }}
            transition={{ duration: 1.5, repeat: Infinity }}
          >
            <ChevronDown className="w-5 h-5 text-white/40" />
          </motion.div>
        </motion.div>
      </div>
    </section>
  )
}
